import React from 'react';
import './css/bootstrap.css';
import './App.css';
import { RouterProvider, createHashRouter, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import { getRoutes } from './utils/getRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotAuthorized from './components/NotAuthorized/NotAuthorized';
import ProtectedRoute from './components/common/ProtectedRoute/ProtectedRoute';

const AppRouter = () => {
  const routesConfig = getRoutes().map((route) => {
    if (route.allowedRoles) {
      return {
        ...route,
        element: (
          <ProtectedRoute
            element={route.element}
            allowedRoles={route.allowedRoles}
          />
        ),
      };
    }
    return route;
  });

  const router = createHashRouter([
    {
      path: "/",
      element: <Navigate to="/login" replace />
    },
    ...routesConfig,
    { 
      path: "/not-authorized",
      element: <NotAuthorized /> 
    }
  ]);

  return <RouterProvider router={router} />;
};

const App = () => {
  return (
    <Provider store={store}>
      <AppRouter />
      <ToastContainer />
    </Provider>
  );
};

export default App;